/**
 * 给出某页数据。page(list, current, page) 或者 page(list, {current, page})
 * 比如 page(list, {current: 1, page: 10}) 返回第 0 到第 9 的数据
 * @param list
 * @param current
 * @param page
 * @returns {*}
 */
export default function (list, current, page) {
  if (!list || !list.length) return []
  if (current && typeof current === 'object') {
    page = current.page
    current = current.current
  }
  if (!current || current < 1) current = 1
  page = page || 20
  let max = Math.ceil(list.length / page)
  if (current > max) current = max
  return list.slice((current - 1) * page, current * page)
}



// WEBPACK FOOTER //
// ./src/utils/page.js